import axios from "axios";
import { retrieveData,removeData } from "../LocalConnection/LocalConnection";

/* ================= BASE URL ================= */
let APL_LINK = "http://localhost:5050/";
APL_LINK = "https://backend-lazyx.onrender.com/";
let local_server_link_react = APL_LINK + "api/admin_link/";

/* ================= ADMIN APIS ================= */
const login_admin = local_server_link_react + "login";
const login_admin_google = local_server_link_react + "admin/login/google";
const analytics_data = local_server_link_react + "analytics";
const create_admin_order = local_server_link_react + "create_order";
const get_user_data = local_server_link_react + "get_user_data";
const user_active_deactive_status = local_server_link_react + "user_status";
const get_all_collections = local_server_link_react + "get_collections";
const add_collection = local_server_link_react + "add_collection";
const product_by_category =
  local_server_link_react + "product/product_by_category";
const delete_collection = local_server_link_react + "delete_collection";
const product = local_server_link_react + "product";
const get_product_data = local_server_link_react + "product";
const save_product = local_server_link_react + "product/save";
const delete_product = local_server_link_react + "product/delete_product";
const product_status = local_server_link_react + "product/status";
const get_all_orders = local_server_link_react + "get_all_orders";
const update_order_status = local_server_link_react + "update_order_status";
const get_order_detail = local_server_link_react + "get_order_detail";
const push_order_qikink = local_server_link_react + "push_to_qikink";
const mark_order_paid = local_server_link_react + "mark_order_paid";
const get_notifications = local_server_link_react + "notifications";
const mark_notification_read = local_server_link_react + "notifications/read";
const un_red_notifications =
  local_server_link_react + "notifications/unread-count";
const abandone_admin =
  local_server_link_react + "abandoned/admin";
const abandone_recovered =
  local_server_link_react + "abandoned/recovered";
const get_contacts = local_server_link_react + "get_contacts";

/* ================= BLOG APIS ================= */
const get_blog_category = local_server_link_react + "get_blog_category";
const add_blog_category = local_server_link_react + "add_blog_category";
const delete_blog_category = local_server_link_react + "delete_blog_category";
const get_blog = local_server_link_react + "get_blog";
const save_blog = local_server_link_react + "save_blog";
const delete_blog = local_server_link_react + "delete_blog";
const get_all_pod = local_server_link_react + "get_all_pod";

/* ================= HELPERS ================= */
const getFreshToken = () => retrieveData("lazyx_admin_token");

/* ================= POST (FORM DATA) ================= */
const server_post_data = async (url_for, form_data = new FormData()) => {
  try {
    const auth_token = getFreshToken();

    return await axios.post(url_for, form_data, {
      headers: {
        Accept: "application/json",
        Authorization: auth_token ? `Bearer ${auth_token}` : "",
      },
    });
  } catch (error) {
    if (error?.response?.status === 401) {
      window.dispatchEvent(new Event("TOKEN_EXPIRED"));
    }
    throw error;
  }
};

/* ================= POST (JSON) ================= */
const server_post_json = async (url_for, data = {}) => {
  const auth_token = getFreshToken();

  // 🚫 NO TOKEN = DO NOT CALL API
  if (!auth_token) {
    window.dispatchEvent(new Event("TOKEN_EXPIRED"));
    return Promise.reject("NO_TOKEN");
  }

  try {
    return await axios.post(url_for, data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${auth_token}`,
      },
    });
  } catch (error) {
    if (error?.response?.status === 401) {
      // 🔥 HARD STOP ALL FUTURE CALLS
      removeData();
      window.dispatchEvent(new Event("TOKEN_EXPIRED"));
    }
    throw error;
  }
};



/* ================= EXPORTS ================= */
export {
  APL_LINK,
  server_post_data,
  server_post_json,
  create_admin_order,
  get_all_collections,
  product_by_category,
  login_admin,
  login_admin_google,
  get_user_data,
  user_active_deactive_status,
  delete_collection,
  get_notifications,
  mark_notification_read,
  un_red_notifications,
  get_contacts,
  get_all_orders,
  update_order_status,
  push_order_qikink,
  get_order_detail,
  get_blog,
  save_blog,
  delete_blog,
  add_blog_category,
  get_blog_category,
  delete_blog_category,
  add_collection,
  product,
  get_product_data,
  save_product,
  delete_product,
  product_status,
  analytics_data
  ,mark_order_paid,
  abandone_admin,
  abandone_recovered,
  get_all_pod
};
